module.exports = __webpack_public_path__ + "img/be-present.dbe590e9.png";